<template>
  <div>
    <div class="d-left">
      <erp-tree @node-click="nodeClick"></erp-tree>
    </div>
    <div class="d-right">
      <div>
        <el-button @click="search">查询</el-button>
        <el-button @click="handleTaxInvoice">税局发票查询</el-button>
      </div>
      <el-descriptions
        class="margin-top"
        :column="2"
        size="mini"
        border
        style="margin-top: 8px"
      >
        <el-descriptions-item label="发票抬头">
          <el-input
            size="mini"
            v-model="form.title"
            placeholder="输入发票抬头搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="房产/项目">
          <el-input
            v-model="form.houseName"
            size="mini"
            placeholder="输入房产或项目名称搜索"
          />
        </el-descriptions-item>
        <el-descriptions-item label="发票号码">
          <el-input
            size="mini"
            v-model="form.invoiceNo"
            placeholder="输入发票号码搜索"
          ></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="开票时间">
          <el-date-picker
            v-model="startDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择开始日期"
          />
          至
          <el-date-picker
            v-model="endDate"
            size="mini"
            type="date"
            format="yyyy-MM-dd"
            value-format="timestamp"
            placeholder="选择结束日期"
          />
        </el-descriptions-item>
        <el-descriptions-item label="操作">
          <el-button @click="downloadInvoice">ERP开票列表</el-button>
          <el-button @click="notReceiptInvoice">非ERP开票列表</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="税盘">
          <el-select v-if="discList.length > 1" v-model="form.disc_id">
            <el-option v-for="item in discList" :key="item.id" :label="'开票人：' + item.drawer + ' 备注：' + item.remark" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
      </el-descriptions>
      <el-table
        max-height="750px"
        :data="listData"
        border
        style="margin-top: 8px"
      >
        <el-table-column label="发票抬头" prop="title" width="100" />
        <el-table-column label="纳税人识别号" width="200" >
          <template slot-scope="scope">
            <b>{{ scope.row.tax_number }}</b>
          </template>
        </el-table-column>
        <el-table-column label="收据号" prop="bill_no"></el-table-column>
        <el-table-column label="房产" prop="address" width="300" />
        <el-table-column label="开票金额" prop="amount" width="100" />
        <el-table-column label="税额" prop="tax_amount"></el-table-column>
        <el-table-column label="税前金额" prop="order_total" width="100" />
        <el-table-column label="发票号码" prop="invoice_no" />
        <el-table-column label="备注" prop="remark" />
        <el-table-column label="开票时间" prop="date" width="150" />
        <el-table-column label="是否红冲" prop="is_canceled" width="100" />
        <el-table-column label="红冲时间" prop="canceled_at" width="150" />
        <el-table-column label="红冲原因" prop="red_reason"></el-table-column>
        <el-table-column label="操作" width="230">
          <template slot-scope="data">
            <el-button size="mini" type="text" @click="viewInvoiceUrl(data.row.id, 1)">查看发票</el-button>
            <el-button size="mini" type="text" v-if="ERP.isPermission(4004001002) && data.row.is_canceled === '未红冲'"
                       @click="canceledInvoice(data.row.id)">红冲发票</el-button>
            <el-button size="mini" type="text" v-if="data.row.is_canceled === '已红冲'"
                       @click="viewInvoiceUrl(data.row.id, 2)">查看红冲发票</el-button>
            <el-button size="mini" type="text" @click="detail(data.row.id)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="float: right; margin-top: 10px; margin-right: 20px" background :small="true" layout="prev, pager, next" :page-size="form.pageSize"
                     :total="totalCount" :current-page.sync="form.page">
      </el-pagination>

      <el-dialog title="确认红冲发票？" :visible.sync="canceledVisible" width="380px" @close="canceledVisible = false;">
        <el-form v-loading="cancelLoading">
          <el-form-item label="是否同时红冲缴费？">
            <el-select v-model="paymentCancel">
              <el-option :value="1" label="是" ></el-option>
              <el-option :value="0" label="否" ></el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item label="红冲原因类型">-->
<!--            <el-select v-model="redReasonCode" style="width: 100%">-->
<!--              <el-option :value="'01'" label="开票有误"></el-option>-->
<!--              <el-option :value="'02'" label="销货退回"></el-option>-->
<!--              <el-option :value="'03'" label="服务中止"></el-option>-->
<!--              <el-option :value="'04'" label="销售折让"></el-option>-->
<!--            </el-select>-->
<!--          </el-form-item>-->
          <el-form-item label="红冲原因">
            <el-input v-model="redReason" type="textarea" placeholder="请输入红冲原因" rows="3" maxlength="200">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="canceledInvoiceSave" size="small">确定</el-button>
            <el-button @click="canceledVisible = false" size="small">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </div>

    <invoice-detail  v-if="invoiceId > 0" :invoiceId="invoiceId" :visible="invoiceDetailVisible"
                     @close="invoiceDetailVisible = false" :disc_id="form.disc_id"></invoice-detail>

    <el-dialog title="税局发票" :visible.sync="taxInvoice.visible">
      <tax-invoice-list :visible="taxInvoice.visible" @close="taxInvoice.visible = false"
                        :pindex_id="taxInvoice.pindex_id" :disc_id="form.disc_id"></tax-invoice-list>
    </el-dialog>

    <excel-task
      ref="ExcelTask"
      :excelTask="excelTask"
      @close="closeExcelTask"
    />
  </div>
</template>

<script>
import ErpTree from "@/components/Admin/Common/erp-tree";
import InvoiceDetail from "./invoiceDetail.vue";
import TaxInvoiceList from "./TaxInvoiceList.vue";
import ExcelTask from "@/components/common/excelTask";

export default {
  name: "FinanceInvoice",
  components: {
    InvoiceDetail,
    ErpTree,
    TaxInvoiceList,
  },
  data() {
    return {
      listData: [],
      form: {
        title: "",
        houseName: "",
        invoiceNo: "",
        startDate: "",
        endDate: "",
        pid: "",
        page: 1,
        pageSize: 10,
        disc_id : 0,
      },
      startDate: "",
      endDate: "",
      totalCount: 0,
      house: [],

      canceledVisible:false,
      paymentCancel : 0,
      cancelId : 0,
      cancelLoading : false,
      redReasonCode : '01',
      redReason : '',

      invoiceId : 0,
      invoiceDetailVisible : false,

      taxInvoice: {
        visible : false,
        pindex_id : 0
      },

      excelTask: false,
      discList : [],
    };
  },
  mounted() {
    // this.search();
    // startDate 默认当月1号
    let firstDay = new Date(
      new Date().getFullYear(),
      new Date().getMonth() ,
      1
    );
    this.startDate = firstDay.getTime();
  },
  watch: {
    "form.page"(n) {
      this.search();
    },
    "form.pid"(n){
      this.$myhttp
        .post(
          "admin/InvoiceDisc/checkIsDigitization",
          { pid: n},
          {
            "Content-Type": "application/json",
          }
        ).then(backdata => {
          if (backdata.data.code == 200) {
            if(backdata.data.data.hasOwnProperty('disc_list') && backdata.data.data.disc_list.length > 1){
              this.discList = backdata.data.data.disc_list;
              this.form.disc_id = backdata.data.data.disc_list[0].id;
            }else{
              this.discList = [];
              this.form.disc_id = 0;
            }
          }
        })
    },
  },
  methods: {
    nodeClick(data) {
      this.form.pid = data.tree[0].projectId
      let tree_str = data.tree
        .map((ret) => {
          return ret.name;
        })
        .join("->");
      this.form.houseName = tree_str;
    },
    search() {
      if(this.form.pid === ''){
        this.$message.error("请选择项目");
        return;
      }

      this.form.startDate = this.startDate / 1000;
      this.form.endDate = this.endDate / 1000;
      this.$myhttp
        .post("admin/Invoice/index", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            this.form.page = backdata.data.page;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    viewInvoiceUrl(id, type) {
      this.$myhttp
        .post(
          "admin/Invoice/getInvoiceUrl",
          { id, type , disc_id : this.form.disc_id},
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            window.open(backdata.data.url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    canceledInvoiceSave(){
      this.$myhttp
        .post(
          "admin/Invoice/canceledInvoice",
          {
            id : this.cancelId ,
            is_red_order : this.paymentCancel ,
            disc_id : this.form.disc_id ,
            reason_code : this.redReasonCode ,
            reason : this.redReason
          },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.canceledVisible = false;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    canceledInvoice(id) {
      // this.canceledVisible = true;
      this.cancelId = id;
      this.canceledInvoiceSave();
    },
    downloadInvoice(){
      if(this.form.pid === ''){
        this.$message.error("请选择项目");
        return;
      }
      if(this.startDate === ''){
        this.$message.error('请选择开票时间筛选开始时间');
        return ;
      }else{
        this.form.startDate = this.startDate / 1000;
      }
      if(this.endDate === ''){
        // 默认为当天
        this.form.endDate = new Date().getTime() / 1000;
      }else{
        this.form.endDate = this.endDate / 1000;
      }
      // 判断startDate - endDate 是否超过一年
      let startDate = new Date(this.form.startDate * 1000);
      let endDate = new Date(this.form.endDate * 1000);
      if((endDate.getTime() - startDate.getTime()) > (366 * 24 * 60 * 60 * 1000)){
        this.$message.error('开票时间筛选时间范围不能超过一年');
        return ;
      }
      let that = this;
      this.$myhttp
        .post("admin/invoiceDownload", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            window.open(that.$myhttp.defaults.baseURL +  backdata.data.data, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });


    },
    detail(id){
      this.invoiceId = id;
      this.invoiceDetailVisible = true;
    },

    handleTaxInvoice(){
      if(this.form.pid === ''){
        this.$message.error("请选择项目");
        return;
      }
      this.taxInvoice.pindex_id = this.form.pid;
      this.taxInvoice.visible = true;
    },

    notReceiptInvoice(){
      if(this.form.pid === ''){
        this.$message.error("请选择项目");
        return null;
      }
      if(this.startDate === ''){
        this.$message.error('请选择开票时间筛选开始时间');
        return null ;
      }else{
        this.form.startDate = this.startDate / 1000;
      }
      if(this.endDate === ''){
        // 默认为当天
        this.form.endDate = new Date().getTime() / 1000;
      }else{
        this.form.endDate = this.endDate / 1000;
      }
      // 判断startDate - endDate 是否超过一年
      let startDate = new Date(this.form.startDate * 1000);
      let endDate = new Date(this.form.endDate * 1000);
      if((endDate.getTime() - startDate.getTime()) > (366 * 24 * 60 * 60 * 1000)){
        this.$message.error('开票时间筛选时间范围不能超过一年');
        return null;
      }
      let that = this;
      this.$myhttp.post("admin/invoiceBind", {
        project_id : this.form.pid,
        start_date : startDate.getFullYear() + '-' + (startDate.getMonth() + 1) + '-' + startDate.getDate() ,
        end_date : endDate.getFullYear() + '-' + (endDate.getMonth() + 1) + '-' + endDate.getDate()
      }, {
          "Content-Type": "application/json",
        }).then((res) => {
          console.log(res)
          if (res.data.code == 200) {
            that.$message.success('创建任务成功');
            that.openExcelTask();
          }else{
            that.$message.error(res.data.msg);
          }
      })

    },
    openExcelTask() {
      this.excelTask = true;
      // this.$refs.ExcelTask.change(1);
    },
    closeExcelTask() {
      this.excelTask = false;
    },
  },
};
</script>

<style>
.d-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
  width: 250px;
  float: left;
}
.d-right {
  float: right;
  width: calc(100% - 260px);
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Finance/invoice.vue